import { connect } from 'react-redux';
import {
  getFilters,
  getPagination,
  createChild,
  searchPages,
  creatingChild,
} from 'store/modules/pages';
import { getLocales } from 'store/modules/company';
import { push } from 'react-router-redux';
import Language from '../components/PageList/Language';

const mapStateToProps = state => ({
  filters: getFilters(state),
  pagination: getPagination(state),
  siteLanguages: getLocales(state),
  creatingChild: creatingChild(state),
});

const mapDispatchToProps = dispatch => ({
  pushRoute: route => dispatch(push(route)),
  onEnable: (page, locale) =>
    dispatch(createChild(page, locale)).then(() =>
      dispatch(searchPages())),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Language);
